import { Fragment } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { BreadCrumb } from "primereact/breadcrumb";

import { Card, CardBody } from "reactstrap";

import { HOME } from "Constant";

import Main from "./Main";

import { getClientCode } from "helper/getDataFromCookies";
import useFetchData from "hooks/useFetchData";

const HomePage = () => {
  const { t } = useTranslation();
  const { data, isLoading, isError } = useFetchData("/front/taxis");
  if (isLoading) return null;
  const breadCrumbsProps = [];

  const clientCode = getClientCode();
  const title = t(HOME);
  const home = { label: title, icon: "pi pi-home" };

  return (
    <Fragment>
      <Card className="mb-0">
        <CardBody>
          <Helmet>
            <title>{title}</title>
          </Helmet>

          <BreadCrumb
            model={[]}
            home={home}
            style={{
              border: "none",
              background: "none",
              boxShadow: "none",
              marginLeft: "-3rem", // ou -2rem selon l'effet désiré
            }}
          />
          <Main clientCode={clientCode} />
        </CardBody>
      </Card>
    </Fragment>
  );
};

export default HomePage;
